module.exports = __webpack_public_path__ + "img/Villa_Borna_15.03b8be40.jpg";